import {REHYDRATE} from 'redux-persist';
import moment from 'moment';

const currentYear = new Date().getFullYear();
  
const years = [];

for (var year = 2020; year <= currentYear; year++) {
  years.push(year);
}

const initialState = {
  weatherStations: [],
  locationEnabled: false,
  selectedWeatherStation: null,
  //selectedWeatherStationSensorData: {},
  selectedWeatherStationHistoricalData: [],
  weatherStationModalVisible: false,
  historicalStartDate: new moment().subtract(1, 'days').toDate(),
  historicalEndDate: new moment().toDate(),
  fetchingWeatherStations: false,
  //fetchingSensorData: false,
  fetchingHistoricalData: false,
  dataPointDropDownListDataSource: [
    {
      label: 'Temperature',
      value: 'temperature',
    },
    {
      label: 'Last 24 Hours Rainfall',
      value: 'last24HoursRainfall',
    },
    {
      label: 'Last Month Rainfall',
      value: 'lastMonthRainfall',
    },
    {
      label: 'Windspeed',
      value: 'windspeed',
    },
    {
      label: 'Wind Direction',
      value: 'windDirection',
    },
    {
      label: 'Heat Index',
      value: 'heatIndex',
    },
    {
      label: 'Dew Point',
      value: 'dewPoint',
    },
    {
      label: 'Barometer',
      value: 'barometer',
    },
    {
      label: 'Humidity',
      value: 'humidity',
    },
    {
      label: 'Soil Temp',
      value: 'soilTemp',
    },
  ],
  selectedDataPoint1: 'temperature',
  selectedDataPoint2: 'last24HoursRainfall',
  selectedDataPoint3: 'windspeed',
  fetchingHistoricalAverages: false,
  selectedWeatherStationMonthlyHistoricalAverages: [],
  selectedWeatherStationWeeklyHistoricalAverages: [],
  years: years,
  selectedYear: currentYear,
  reportWeatherStationModalVisible: false,
  weatherStationIssueCustomerName: '',
  weatherStationNameToReport:'',
  weatherStationIssueToReport: '',
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.weatherStations,
          weatherStations: [],
          locationEnabled: false,
          selectedWeatherStation: null,
          //selectedWeatherStationSensorData: {},
          selectedWeatherStationHistoricalData: [],
          weatherStationModalVisible: false,
          historicalStartDate: new moment().subtract(1, 'days').toDate(),
          historicalEndDate: new moment().toDate(),
          fetchingWeatherStations: false,
          //fetchingSensorData: false,
          fetchingHistoricalData: false,
          dataPointDropDownListDataSource: initialState.dataPointDropDownListDataSource,
          fetchingHistoricalAverages: false,
          selectedWeatherStationMonthlyHistoricalAverages: [],
          selectedWeatherStationWeeklyHistoricalAverages: [],
          reportWeatherStationModalVisible: false,
          weatherStationIssueCustomerName: '',
          weatherStationNameToReport: '',
          weatherStationIssueToReport: '',
          years: years,
        };
      }
      return state;

    case 'INIT_WEATHER_STATIONS':
      return {
        ...state,
        weatherStations: [],
        weatherStationsDropDownListDataSource: [],
        selectedWeatherStation: null,
        //selectedWeatherStationSensorData: {},
        selectedWeatherStationHistoricalData: [],
        fetchingHistoricalAverages: false,
        selectedWeatherStationMonthlyHistoricalAverages: [],
        selectedWeatherStationWeeklyHistoricalAverages: [],
        reportWeatherStationModalVisible: false,
        weatherStationIssueCustomerName: '',
        weatherStationNameToReport: '',
        weatherStationIssueToReport: '',
      };

    case 'USER_REQUESTED_FETCH_WEATHER_STATIONS':
      return {
        ...state,
        fetchingWeatherStations: true,
      };

    case 'TOGGLE_LOCATION_BASED_SORTING':
      return {
        ...state,
        locationEnabled: !state.locationEnabled,
      };

    case 'FETCHED_WEATHER_STATIONS':
      return {
        ...state,
        weatherStations: action.weatherStations,
        fetchingWeatherStations: false,
        selectedWeatherStation: state.locationEnabled === true ? action.weatherStations[0] : state.selectedWeatherStation,
      };

    case 'FETCH_WEATHER_STATIONS_FAILED':
      return {
        ...state,
        fetchingWeatherStations: false,
      };

    case 'USER_SELECTED_WEATHER_STATION':
      return {
        ...state,
        selectedWeatherStation: action.weatherStation,
        //selectedWeatherStationSensorData: {},
        selectedWeatherStationHistoricalData: [],
      };

    /*
    case 'USER_REQUESTED_WEATHER_STATION_SENSOR_DATA':
      return {
        ...state,
        fetchingSensorData: true,
      };
      
    case 'FETCHED_WEATHER_STATION_SENSOR_DATA':
      return {
        ...state,
        selectedWeatherStationSensorData: action.sensorData,
        fetchingSensorData: false,
      };

    case 'FETCH_WEATHER_STATION_SENSOR_DATA_FAILED':
      return {
        ...state,
        fetchingSensorData: false,
      };
    */

    case 'USER_REQUESTED_TO_FETCH_WEATHER_STATION_HISTORICAL_DATA':
      return {
        ...state,
        fetchingHistoricalData: true,
      };

    case 'FETCHED_WEATHER_STATION_HISTORICAL_DATA':
      return {
        ...state,
        selectedWeatherStationHistoricalData: action.historicalData,
        fetchingHistoricalData: false,
      };

    case 'FETCH_WEATHER_STATION_HISTORICAL_DATA_FAILED':
      return {
        ...state,
        fetchingHistoricalData: false,
      };

    case 'SHOW_WEATHER_STATION_MODAL':
      return {
        ...state,
        weatherStationModalVisible: true,
      };

    case 'HIDE_WEATHER_STATION_MODAL':
      return {
        ...state,
        weatherStationModalVisible: false,
      };

    case 'USER_SELECTED_HISTORICAL_WEATHER_START_DATE':
      return {
        ...state,
        historicalStartDate: action.startDate,
      };

    case 'USER_SELECTED_HISTORICAL_WEATHER_END_DATE':
      return {
        ...state,
        historicalEndDate: action.endDate,
      };

    case 'USER_SELECTED_WEATHER_STATION_DATA_POINT1':
      return  {
        ...state,
        selectedDataPoint1: action.dataPoint,
      };

    case 'USER_SELECTED_WEATHER_STATION_DATA_POINT2':
      return  {
        ...state,
        selectedDataPoint2: action.dataPoint,
      };

    case 'USER_SELECTED_WEATHER_STATION_DATA_POINT3':
      return  {
        ...state,
        selectedDataPoint3: action.dataPoint,
      };

    case 'USER_SELECTED_YEAR':
      return {
        ...state,
        selectedYear: action.year,
      };
      
    case 'USER_REQUESTED_FETCH_WEATHER_STATION_HISTORICAL_AVERAGES':
      return {
        ...state,
        fetchingHistoricalAverages: true,
      };

    case 'FETCHED_WEATHER_STATION_HISTORICAL_AVERAGES':
      return {
        ...state,
        fetchingHistoricalAverages: false,
        selectedWeatherStationMonthlyHistoricalAverages: action.monthlyHistoricalAverages,
        selectedWeatherStationWeeklyHistoricalAverages: action.weeklyHistoricalAverages,
      };

    case 'FETCH_WEATHER_STATION_HISTORICAL_AVERAGES_FAILED':
      return {
        ...state,
        fetchingHistoricalAverages: false,
      };

    case 'SHOW_REPORT_WEATHER_STATION_MODAL':
      return {
        ...state,
        reportWeatherStationModalVisible: true,
        weatherStationIssueCustomerName: action.customerName,
        weatherStationNameToReport: state.selectedWeatherStation?.stationName,
        weatherStationIssueToReport: '',
      };

    case 'HIDE_REPORT_WEATHER_STATION_MODAL':
      return {
        ...state,
        reportWeatherStationModalVisible: false,
      };

    case 'SET_WEATHER_STATION_ISSUE_CUSTOMER_NAME':
      return {
        ...state,
        weatherStationIssueCustomerName: action.customerName,
      };

    case 'SET_WEATHER_STATION_NAME_TO_REPORT':
      return {
        ...state,
        weatherStationNameToReport: action.stationName,
      };

    case 'SET_WEATHER_STATION_ISSUE_TO_REPORT':
      return {
        ...state,
        weatherStationIssueToReport: action.issue,
      };

    default:
      return state;
  }
}
